module.exports = __webpack_public_path__ + "img/icon_my1.c1ea60e8.png";